import React from 'react';
import { H1, Icons } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { AppPermissions } from '@erecruit/types';
import { default as ProfileSettings } from './components/ProfileSettings';
import { DataPreferences } from './components/DataPreferences';
import { About } from './components/About';
import { NotificationSettings } from './components/NotificationSettings';
import { Appearance } from './components/Appearance';

export type SettingItem = {
  title: Intl.LocalizationKeysArray;
  icon: Icons;
  route: string;
  content: React.FunctionComponent;
  permission?: string;
};

const Placeholder = () => <H1>Coming soon...</H1>;
const setRoute = (section: string) => `/settings?section=${section}`;

export enum SettingsKey {
  Profile = 'profile',
  Data = 'data',
  Notifications = 'notifications',
  Help = 'help',
  About = 'about',
  Appearance = 'appearance',
}

export const settingsMap: Record<SettingsKey, SettingItem> = {
  [SettingsKey.Profile]: {
    icon: 'user',
    title: messageIds.vms.settings.profile,
    content: () => <ProfileSettings />,
    route: setRoute(SettingsKey.Profile),
  },
  [SettingsKey.Data]: {
    icon: 'settings',
    title: messageIds.vms.settings.data.heading,
    content: () => <DataPreferences />,
    route: setRoute(SettingsKey.Data),
    permission: AppPermissions.DataPreferences,
  },
  [SettingsKey.Notifications]: {
    icon: 'notification',
    title: messageIds.vms.settings.notifications.heading,
    content: () => <NotificationSettings />,
    route: setRoute(SettingsKey.Notifications),
    permission: AppPermissions.NotificationSettings,
  },
  [SettingsKey.Help]: {
    icon: 'light',
    title: messageIds.vms.settings.help,
    content: () => <Placeholder />,
    route: setRoute(SettingsKey.Help),
  },
  [SettingsKey.About]: {
    icon: 'info',
    title: messageIds.vms.settings.about,
    content: () => <About />,
    route: setRoute(SettingsKey.About),
  },
  [SettingsKey.Appearance]: {
    icon: 'palette',
    title: messageIds.vms.settings.appearance.pageTitle,
    content: () => <Appearance />,
    route: setRoute(SettingsKey.Appearance),
  },
};
